/**
 * Enumeration values maps to API-defined contact status values.
 */
export enum CiviCRMContactStatusEnum {
    LinkedToActiveEwaAccount = 1,
    LinkedToPendingEwaAccount = 2,
    LinkedToRejectedEwaAccount = 3,
    LinkedToInactiveEwaAccount = 4,
    UnlinkedWithUniquePrimaryEmail = 5,
    UnlinkedWithNonUniquePrimaryEmail = 6,
    UnlinkedWithNoPrimaryEmail = 7,
}
